import { render, staticRenderFns } from "./dynamicData.vue?vue&type=template&id=3ef6c4cf&scoped=true&"
import script from "./dynamicData.vue?vue&type=script&lang=js&"
export * from "./dynamicData.vue?vue&type=script&lang=js&"
import style0 from "./dynamicData.vue?vue&type=style&index=0&id=3ef6c4cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6c4cf",
  null
  
)

export default component.exports